<div class="button-menu">
  @for (size of sizes(); track $index) {
    <app-button-menu-item
      [name]="'download-' + (size.name | lowercase)"
      location="download-size-selection"
      (click)="onSelect.emit(size.size)"
      [fullWidth]="true"
    >
      <div class="download-menu-item">
        <b>{{ size.name | capitalize }}</b>
        @if (size.width && size.height) {
          <span>({{ size.width }} x {{ size.height }})</span>
        }
      </div>
    </app-button-menu-item>
  }
  @if (allowOriginalDownload()) {
    @if (sizes().length) {
      <div class="divider"></div>
    }
    <app-button-menu-item
      name="download-original"
      location="download-size-selection"
      (click)="onSelect.emit(undefined)"
      [fullWidth]="true"
    >
      <div class="download-menu-item">
        <b>Original File</b>
        @if (asset().version_data.data?.['width']) {
          <span>({{ asset().version_data.data['width'] }} x {{ asset().version_data.data['height'] }})</span>
        }
      </div>
    </app-button-menu-item>
  }
</div>
